import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { CreateBancoRequest } from '@models/banco/createBancoRequest.model';
import { UpdateBancoRequest } from '@models/banco/updateBancoRequest.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { TipoCaracteristicaPropiedadDto } from '@models/propiedades/tipoCaracteristicaPropiedadDto.model';
import { BancosService } from '@services/bancos/bancos.service';
import { PropietariosService } from '@services/propietarios/propietarios.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogBancoComponent } from '../dialog-banco/dialog-banco.component';

@Component({
  selector: 'app-bancos',
  templateUrl: './bancos.component.html',
  styleUrls: ['./bancos.component.css']
})
export class BancosComponent implements OnInit {

  dataSource = new MatTableDataSource<TipoCaracteristicaPropiedadDto>();
  obj?: any
  displayedColumns: string[] = ['descripcion', 'accion'];
  data = false

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  constructor(
    public dialog: MatDialog,
    public propietariosService: PropietariosService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private bancosService: BancosService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'accion'] :
        ['descripcion', 'accion'];
    });

  }


  ngOnInit() {
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.getAllBancos(); //Colocarlo dentro de esto colocama mejor rendimiento.
  }

  getAllBancos() {
    this.spinner.show()
    this.bancosService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()))
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;
    const dialogRef = this.dialog.open(DialogBancoComponent, {
      width: '500px',
      data: obj,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Agregar) {
        this.addRowData(result.data);
      } else if (result && result.event == AccionesDialog.Modificar) {
        this.updateRowData(result.data);
      } else if (result && result.event == AccionesDialog.Eliminar) {
        this.deleteRowData(result.data);
      }
    });
  }

  applyFilter(event: any) {
    if (event && event.target && event.target.value !== undefined) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  openDialogAgregar(action: any) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "30%",
      dialogConfig.data = this.obj

    const dialogRef = this.dialog.open(DialogBancoComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Agregar) {
        this.addRowData(result.data);
      } else if (result && result.event == AccionesDialog.Modificar) {
        this.updateRowData(result.data);
      } else if (result && result.event == AccionesDialog.Eliminar) {
        this.deleteRowData(result.data);
      }
    });
  }


  addRowData(row_obj: { descripcion: any }) {
    this.spinner.show()
    let createBancoRequest = new CreateBancoRequest
    createBancoRequest.descripcion = row_obj.descripcion

    let existe = false
    this.dataSource.data.forEach((element, index) => {
      if (element.descripcion === row_obj.descripcion)
        existe = true
    });

    if (createBancoRequest && !existe) {
      this.bancosService.create(createBancoRequest)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data.push({
              id: data.id,
              descripcion: row_obj.descripcion
            });
            this.table.renderRows();
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string }, key: any) => {
              return true;
            });
            this.data = this.dataSource.data.length >= 1 ? true : false
            this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError(error, "Error");
          }
        )
    }
    else {
      this.spinner.hide()
      this.snackBar.showWarn("El registro ya existe", "Error");
    }

  }
  updateRowData(row_obj: { id: number; descripcion: string }) {
    this.spinner.show()
    let updateBancoRequest = new UpdateBancoRequest
    updateBancoRequest.id = row_obj.id
    updateBancoRequest.descripcion = row_obj.descripcion

    let existe = false
    this.dataSource.data.forEach((element, index) => {
      if (element.descripcion === row_obj.descripcion)
        existe = true
    });
    if (updateBancoRequest && !existe) {
      this.bancosService.update(updateBancoRequest)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string }, key: any) => {
              if (value.id == row_obj.id) {
                value.descripcion = row_obj.descripcion;
              }
              return true;
            });
            this.data = this.dataSource.data.length >= 1 ? true : false
            this.snackBar.showSuccess("Registro actualizado correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError(error, "Error");
          })
    }
    else {
      this.spinner.hide()
      this.snackBar.showWarn("El registro ya existe", "Error");
    }
  }


  deleteRowData(row_obj: { id: number; }) {
    this.bancosService.delete(row_obj.id)
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = this.dataSource.data.filter((value: { id: number; }, key: any) => {
            return value.id != row_obj.id;
          });
          this.data = this.dataSource.data.length >= 1 ? true : false
          this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        })

  }





}
